/**************************************************************************************************/
/** @import Helpers/Documents                                                                    **/
/**************************************************************************************************/
import * as ComponentsPDF from '@/Helpers/Documents/LegacyPDF/ComponentsPDF'
import { ContainerPDF } from '@/Helpers/Documents/LegacyPDF/ContainerPDF'
import { TextPDF } from '@/Helpers/Documents/LegacyPDF/ElementsPDF'
import { PDFRectangle } from '@/Helpers/Documents/LegacyPDF/GeometryPDF'
import { LegacyPDF } from '@/Helpers/Documents/LegacyPDF/LegacyPDF'
import * as TablePDF from '@/Helpers/Documents/LegacyPDF/TablePDF'
import { UtilsPDF } from '@/Helpers/Documents/LegacyPDF/UtilsPDF'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { AppValues } from '@/Constants/AppValues'

/**************************************************************************************************/
/** @internal Function @name AddCheckListNumber                                                  **/
/**************************************************************************************************/
function AddCheckListNumber(pdf: LegacyPDF, code: string)
{
	pdf.setFont('OpenSans-Bold').setFontColor('#314867').setFontSize(10)
	pdf.addText(`N° Registro: ${ code }`, 0, 16, 0, true)
}

/**************************************************************************************************/
/** @internal Function @name GetCompanyLogo                                                      **/
/**************************************************************************************************/
function GetCompanyLogo()
{
	return require('@/Resources/Images/LogoKreisSmall.png')
}

/**************************************************************************************************/
/** @export Function @name GeneratePDF                                                           **/
/**************************************************************************************************/
export function GeneratePDF(cols: Array<TablePDF.TableColumnPDF>, rows: Array<any>, item: any)
{
	// Instancia de la clase PDF.
	const pdf = new LegacyPDF({}, { drawHeaderSafeArea: false, drawFooterSafeArea: false }).create()

	// Otras Instancias relacionadas a PDF.
	const utils = new UtilsPDF()

	// La ubicación de las propiedades cambia según la pestaña de la vista.
	const _idCheckList   = item._idChecklist                || item?.checkList._id        || 'N/A'
	const auditCode      = item?.dataSetting?.auditCode     || item?.auditCode            || null
	const auditDate      = item?.dataSetting?.auditDate     || item?.auditDate            || null
	const comment        = item?.comment                    || item?.checkList?.comment   || 'N/A'
	const hourmeter      = item?.hourmeter                  || item?.checkList?.hourmeter || null
	const codeEquipment  = item.codeEquipment               || item.code                  || 'N/A'
	const date           = item.date                        || item.dateCheckList         || 'N/A'

	// Header
	new ComponentsPDF.HeaderPDF(pdf, 'Formulario', GetCompanyLogo())

	// SubHeader.
	utils.addSubHeaderAndInfoToRight(pdf, 'CheckList', auditCode ? `Cód. Auditoria: ${ auditCode }` : '', auditDate ? `Fecha Vigencia: ${ auditDate }` : '')

	// Numero de Registro.
	AddCheckListNumber(pdf, _idCheckList)

	// Tabla (Izquierda) con la información del Cliente y Ubicación.
	utils.addTableClientInformation(pdf, item.company, item.storage)

	// Tabla (Derecha) con la información de la Fecha y Responsable.
	utils.addTableDateResponsibleInformation(pdf, date, item.operator)

	// Información General del Registro.
	new PDFRectangle(pdf, 0, 16, 8, 44, '#FD921A').setIncludeHeight(false).draw()

	// Valor del Horómetro (si aplica).
	const _hourmeter = hourmeter && hourmeter !== AppValues.Strings.DEFAULT_EMPTY_STRING ? `${ hourmeter } Hrs.` : 'No aplica'
	new ContainerPDF(pdf, 9, 0, 'F', 'A')
		.setPadding(8)
		.addElement(new TextPDF(`Activo: ${ codeEquipment } ${ item?.groupArticle ? ` - ${ item?.groupArticle }` : '' }`, 0, 16, '#127B2D').setFont('OpenSans-Bold').setGap(4))
		.addElement(new TextPDF(`Horómetro: ${ _hourmeter }`, 0, 10, '#2c4d35'))
		.draw()
	;

	// Tabla Principal del Documento PDF.
	const tableData = new TablePDF.TablePDF(pdf, 0, 16, cols, rows)

	// Agregar una Callback que ajustará la posición de la tabla en la nueva pagina (si es creada).
	tableData
		.setMargin('bottom', 0)
		.onCellBeforeDraw((data) =>
		{
			//	Ajustar la posición de la tabla (en nuevas páginas).
			TablePDF.TableExtraMarginOnNewPageCreation(pdf, data, 'num', 16)

			// Ajustar la alineación de columnas especificas.
			TablePDF.TableSetSpecificBodyCellStyle(data, 'num', 'halign', 'center')
			TablePDF.TableSetSpecificBodyCellStyle(data, 'status', 'halign', 'center')

			// Agregar una Imagen en cada Celda de una Columna.
			if (data.section === 'body' && data.column.dataKey === 'status')
			{
				const cellHeight = data.cell.height - data.cell.padding('vertical')
				const textPos = data.cell.getTextPos()
				const checkIcon = new Image().src = require('@/Resources/Icons/CheckCircleSolid.png')
				const timesIcon = new Image().src = require('@/Resources/Icons/TimesCircleSolid.png')
				const image = data.cell.text[0] === 'true' ? checkIcon : timesIcon
				pdf.getGlobalDoc().addImage(image, 'PNG', textPos.x - (12 * .5), textPos.y - (cellHeight * .5), 12, cellHeight)
				data.cell.text[0] = ''
			}
		})
		.draw()
	;

	// Incluir el Comentario despues de la Tabla.
	new ContainerPDF(pdf, 0, 16, 'F', 80).setBorderColor('#DDDDDD').setPadding(8)
		.addElement(new TextPDF('Comentario:', 0, 10, '#D36900').setFont('OpenSans-Bold').setGap(4))
		.addElement(new TextPDF(comment, 0, 10))
		.draw()
	;

	// Footer
	new ComponentsPDF.FooterPDF(pdf, 'KREIS SpA', 'Av. Pdte Jorge Alessandri 11832 - San Bernardo - Chile')

	// El numero de páginas debe ser lo ultimo que se agregue al documento PDF.
	pdf.addNumberOfPages()

	// Finalmente, abrir el archivo PDF en una nueva pestaña.
	pdf.open('Informe CheckList')
}